// import { useMemo, useState } from 'react';
// import { Helmet } from 'react-helmet-async';
// import { Link } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { Modal } from 'react-bootstrap';
// import { CSSTransition } from 'react-transition-group';

// import Swal from 'sweetalert2'
// import axios from 'axios'
// // @mui
// import { Button, Container, Stack, Typography } from '@mui/material';

// // components
// import Iconify from '../components/iconify';
// import { Url, awsFileUrl } from '../url/url';
// import { categorydata } from '../redux/slice/category'
// import { subcategorydata } from '../redux/slice/subcategory'
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { characterdata } from '../redux/slice/character';
// import { subcharacterdata } from '../redux/slice/subcharacter';
// // import './ModalExample.css';

// const Category = () => {
//   const dispatch = useDispatch()
//   const [color, setColor] = useState('#000000');
//   const [textColor, setTextColor] = useState('#000000');

//   const categoryalldata = useSelector(store => store.category.data)
//   const subcategoryalldata = useSelector(store => store.subcategory.data)
//   const characteralldata = useSelector(store => store.character.data)
//   const subcharacteralldata = useSelector(store => store.subcharacter.data)
//   const [activeModal, setActiveModal] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [formValue, setFormValue] = useState({});
//   const [pathValue, setPathValue] = useState({});
//   const [fileErrMsg, setFileErrMsg] = useState("")

//   const [uploadLoading, setUploadLoading] = useState(false);
//   const [progressValue, setProgressValue] = useState(0);
//   const [uploadStatus, setUploadStatus] = useState(false);
 

//   const openModal = (modalName, path, data = null) => {
//     setActiveModal(modalName);
//     setPathValue(path)
//     if (data && data !== null) {
//       setFormValue(data)
//     }
//   }
//   const closeModal = () => {
//     setActiveModal(null);
//     setFormValue({})
//   };
//   const isModalOpen = (modalName) => {
//     return activeModal === modalName;
//   };
//   const formHandle = (e) => {
//     const name = e.target.name
//     const value = e.target.value
//     const lowerValue = value.toLowerCase();
//     setFormValue({ ...formValue, [name]: lowerValue })
//   }
//   const fileHandle = (e) => {
//     setFileErrMsg('')
//     const name = e.target.name
//     const file = e.target.files[0]
//     if (file.size < 100000) {
//       setFormValue({ ...formValue, [name]: file })
//     } else {
//       setFileErrMsg('Please keep file size less than 100 kb')
//     }
//   }
//   const deleteFunc = async (path) => {
//     Swal.fire({
//       title: 'Are you sure?',
//       text: "You want delete this subcategory",
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#3085d6',
//       cancelButtonColor: '#d33',
//       confirmButtonText: 'Yes, delete it!'
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         await axios.delete(`${Url}${path}`).then(() => {
//           Swal.fire({
//             position: 'top-end',
//             icon: 'success',
//             title: 'Item Delete Successfully',
//             showConfirmButton: false,
//             timer: 1000
//           })
//           dispatch(categorydata())
//           dispatch(subcategorydata())
//           dispatch(characterdata())
//           dispatch(subcharacterdata())
//         }).catch((error) => {
//           Swal.fire({
//             position: 'top-end',
//             icon: 'error',
//             title: 'something went wrong',
//             showConfirmButton: false,
//             timer: 1500
//           })
//         })

//       }
//     })
//   }
//   const formSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true)
//     try {
//       await axios.post(`${Url}${pathValue}`, formValue).then((e) => {
//         Swal.fire({
//           position: 'top-end',
//           icon: 'success',
//           title: 'Create Success',
//           showConfirmButton: false,
//           timer: 1500
//         })
//         setFormValue({})
//         setPathValue('')
//         setLoading(false)
//         dispatch(categorydata())
//         dispatch(subcategorydata())
//         dispatch(characterdata())
//         dispatch(subcharacterdata())
//         closeModal()
//       })
//     } catch (error) {
//       setLoading(false)
//       console.log(error);
//     }
//     setLoading(false)
//   }
//   const bannerUpdate = async (e) => {
//     e.preventDefault();
//     setLoading(true)
//     try {
//       await axios.post(`${Url}${pathValue}`, formValue).then((e) => {
//         Swal.fire({
//           position: 'top-end',
//           icon: 'success',
//           title: 'Create Success',
//           showConfirmButton: false,
//           timer: 1500
//         })
//         setFormValue({})
//         setPathValue('')
//         setLoading(false)
//         dispatch(categorydata())
//         dispatch(subcategorydata())
//         dispatch(characterdata())
//         dispatch(subcharacterdata())
//         closeModal()
//       })
//     } catch (error) {
//       setLoading(false)
//       console.log(error);
//     }
//     setLoading(false)
//   }
//   const bannerFileHandle = async (e) => {
//     const file = e.target.files[0]
//     const name = e.target.name
//     setUploadLoading(true)

//     const targetApi = activeModal === "categoryBanner" ? 'category' : activeModal === "characterBanner" ? 'character' : undefined;
   
//     setFileErrMsg('')

//     try {
//       if (file) {
//         if (file.size < 1000000 && targetApi) {
//           const response = await axios.post(`${Url}/api/createPresignedUrl/${targetApi}`, { fileName: file.name, fileType: file.type })
//           if (response.status === 200) {
//             const { preSignedUrl, key, fileType } = response?.data
//             const responseFileSave = await axios.put(preSignedUrl, file, {
//               onUploadProgress: (progressEvent) => {
//                 const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                 setProgressValue(progress)
//               },
//             }) 
//             if (responseFileSave.status === 200) {
//               const fileUrl = `${awsFileUrl}/${key}`
//               setFormValue({ ...formValue, [name]: fileUrl })
//               setUploadStatus(true)
//               setUploadLoading(false)
//               setProgressValue(0)
//             }
//             else {
//               setUploadLoading(false)
//               setProgressValue(0)
//               setUploadStatus(false)
//             }
//             setUploadLoading(false)
//           }
//           setUploadLoading(false)
//         }
//         else {
//           setFileErrMsg('Please keep file size less than 100 kb')
//         }
//       }

//     } catch (error) {
//       console.log(error);
//       setUploadLoading(false)
//     }
//     setUploadLoading(false)
//   }

//   const handleColorChange = (event, id) => {
//     const selectedColor = event.target.value; 
//     updateColorAPI(selectedColor, id);  
//   };

//   const handleTextChange = (event) => {
//     const inputColor = event.target.value;
//     setTextColor(inputColor); // Update the raw input

//     // If valid hex color, update the actual color picker
//     if (isValidHexColor(inputColor)) {
//       setColor(inputColor); // Update the color picker
//       updateColorAPI(inputColor); // Call API to update color
//     }
//   };
//   const isValidHexColor = (colorCode) => {
//     const hexColorRegex = /^#([0-9A-F]{3}){1,2}$/i; // Regex to validate hex color codes
//     return hexColorRegex.test(colorCode);
//   };

//   const updateColorAPI = async(selectedColor, characterId) => { 
//     try {
//       const response = await axios.put(`${Url}/api/character/update-color`, {selectedColor, characterId} )
      
//       dispatch(characterdata()) 
      
//     } catch (error) {
//       console.log(error); 
//     }
//   }

//   const updateIndexFunc = async(e,characterId )=>{ 
//     try {
//       const response = await axios.put(`${Url}/api/character/update-index/${characterId}`, {index:e.target.value} ) 
//       dispatch(characterdata())
//     } catch (error) {
//       console.log("error", error); 
//     }
//   }

//   return (
//     <>
//       <Helmet>
//         <title> Category </title>
//       </Helmet>

//       <Container className='mb-3 border-bottom pb-3 border-top pt-3'>
//         <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
//           <Typography variant="h4" gutterBottom>
//             Category
//           </Typography>
//           <div className='d-flex align-items-center gap-3'>
//             <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={() => openModal('category', '/api/category/create')}> Add New Category </Button>
//             {categoryalldata.length > 0 &&
//               <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={() => openModal('subcategory', '/api/subcategory/create')}> Add New SubCategory</Button>}
//           </div>

//         </Stack>
//         <div className="subcategory-wrap mb-4">
//           <div className="d-flex ">
//             {categoryalldata.length > 0 ? categoryalldata.map((categoryValue) => {
//               return (
//                 <div key={categoryValue._id} className='border'>
//                   <div className="border-bottom">

//                     <div className="d-flex align-items-center justify-content-between bg-light gap-3 px-3 py-2">
//                       <h5 className='text-primary text-capitalize mb-0'>{categoryValue.category}</h5>

//                       <div className="d-flex align-items-center gap-2">
//                         <button className="btn btn-sm" onClick={() => openModal('categoryBanner', `/api/category/banner/${categoryValue._id}`)}> <i className="fa-regular fa-image text-success fa-lg" /></button>
//                         {subcategoryalldata && subcategoryalldata.filter(data => data.category === categoryValue.category).length <= 0 ?
//                           <button className='border-0 bg-transparent' onClick={() => deleteFunc(`/api/category/delete/${categoryValue._id}`)}><i className="fa-solid fa-trash text-danger fa-sm" /></button> : null}
//                       </div>
//                     </div>
//                     {categoryValue.imageUrl &&
//                       <div className='px-3 pb-2'>
//                         <img src={categoryValue.imageUrl} alt="toynique" style={{ width: "250px" }} />
//                       </div>}
//                   </div>


//                   <div>
//                     {subcategoryalldata && subcategoryalldata.filter(data => data.category === categoryValue.category).map(subcategoryValue => {
//                       return (
//                         <div key={subcategoryValue._id} className='d-flex gap-4 justify-content-between py-2 align-items-center px-3 shadow-sm'>
//                           <p className='mb-0 text-capitalize'>{subcategoryValue.subcategory}</p>
//                           <div className="d-flex align-items-cente gap-2">
//                             <button className='btn py-0 btn-sm btn-warning' onClick={() => openModal('subcategory', `/api/subcategory/update/${subcategoryValue._id}`, { category: subcategoryValue.category, subcategory: subcategoryValue.subcategory })}>edit</button>
//                             <button className='btn py-0 btn-sm btn-danger' onClick={() => deleteFunc(`/api/subcategory/delete/${subcategoryValue._id}`)}>remove</button>
//                           </div>

//                         </div>
//                       )
//                     })}
//                   </div>
//                 </div>
//               )
//             }) : <div className='text-center w-100'>NO Category & Subcategory</div>}
//           </div>
//         </div>
//       </Container>
// {/* 
//       <Container>
//         <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
//           <Typography variant="h4" gutterBottom>
//             Character & Subcharacter
//           </Typography>
//           <div className='d-flex align-items-center gap-3'>
//             <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={() => openModal('character', '/api/character/create')}> Add New character </Button>
//             {characteralldata.length > 0 &&
//               <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={() => openModal('subcharacter', '/api/subcharacter/create')}> Add New SubCharacter</Button>}
//           </div>

//         </Stack>
//         <div className="subcategory-wrap mb-4">
//           <div className="d-flex ">
//             {characteralldata.length > 0 ? characteralldata.map((characterValue) => {  
              
//               return (
//                 <div key={characterValue._id} className='border'>
//                   <div className="border-bottom">
//                     <div className="d-flex align-items-center border-bottom justify-content-between bg-light gap-3 px-3 py-2">
//                       <h5 className=' text-capitalize mb-0' style={{'color': `${characterValue.color ? characterValue.color : "black"} `}}>{characterValue.character}</h5>
//                       <div className="d-flex align-items-center gap-2">
                   
//                           <select name="index" id="" style={{minWidth: "50px"}} className='form-control text-center' defaultValue={characterValue.index} onChange={e=>updateIndexFunc(e, characterValue._id)}>
//                             <option value="1">1</option>
//                             <option value="2">2</option>
//                             <option value="3">3</option>
//                             <option value="4">4</option>
//                             <option value="5">5</option>
//                             <option value="6">6</option>
//                             <option value="7">7</option>
//                             <option value="8">8</option>
//                             <option value="9">9</option>
//                           </select>
//                         {subcharacteralldata && subcharacteralldata.filter(data => data.character === characterValue.character).length <= 0 ?
//                           <button className='border-0 bg-transparent' onClick={() => deleteFunc(`/api/character/delete/${characterValue._id}`)}><i className="fa-solid fa-trash text-danger fa-sm" /></button> : null}
//                       </div>
//                     </div>
//                     <div className='d-flex align-items-center justify-content-between px-3 py-1 gap-3'>
//                       <p className='mb-0' style={{'color': `${characterValue.color ? characterValue.color : "black"} `}}>Color : </p>

//                       <input
//                         type="color"
//                         value={characterValue?.color}
//                         className='color-control'
//                         pattern="#[a-f0-9]{6}"
//                         onChange={(e)=>handleColorChange(e, characterValue._id)}   
//                       /> 
//                     </div>
           
//                     <div className='d-flex px-3 gap-3 justify-content-between border-top py-2'>
//                       <div>
//                         <p className='mb-0'>Banner</p>
                       

//                         <button className="edit btn btn-outline-primary btn-sm px-2 py-0 fs-10" onClick={() => openModal('characterBanner', `/api/character/banner/${characterValue._id}`)}> Update</button>

//                       </div>
//                       <div>
//                       <img src={characterValue.imageUrl} alt="toynique" style={{ width: "150px" }} />
//                       </div>
//                     </div>

//                     <div className=' px-3 border-top py-2'>
//                       <div className='d-flex justify-content-between'>
//                       <div>
//                         <p className='mb-0'>Icon </p> 
//                         <button className="edit btn btn-outline-primary btn-sm px-2 py-0 fs-10" onClick={() => openModal('characterBanner', `/api/character/icon/${characterValue._id}`)}> Update</button>
//                       </div>
//                       <div>
//                       <img src={characterValue?.icon} alt="Icon" style={{ width: "80px" }} />
//                       </div>
//                       </div>
               
//                     </div>

//                   </div>
//                   <div>

//                     {subcharacteralldata && subcharacteralldata.filter(data => data.character === characterValue.character).map(subcharacterValue => {
//                       return (
//                         <div key={subcharacterValue._id} className='d-flex gap-4 justify-content-between py-2 align-items-center px-3 shadow-sm'>
//                           <p className='mb-0 text-capitalize'>{subcharacterValue.subcharacter}</p>
//                           <div className="d-flex align-items-cente gap-2">
//                             <button className='btn py-0 btn-sm btn-warning' onClick={() => openModal('subcharacter', `/api/subcharacter/update/${subcharacterValue._id}`, { character: subcharacterValue.character, subcharacter: subcharacterValue.subcharacter })}>edit</button>
//                             <button className='btn py-0 btn-sm btn-danger' onClick={() => deleteFunc(`/api/subcharacter/delete/${subcharacterValue._id}`)}>remove</button>
//                           </div>

//                         </div>
//                       )
//                     })}
//                   </div>
//                 </div>
//               )
//             }) : <div className='text-center h-100 w-100'>No Character & SubCharacter</div>}
//           </div>
//         </div>
//       </Container> */}
 
//       <CSSTransition
//         in={isModalOpen('category')}
//         timeout={300}
//         classNames="modal-transition"
//         unmountOnExit
//       >
//         <Modal show={isModalOpen('category')} onHide={closeModal} centered>
//           <Modal.Header closeButton>
//             <Modal.Title>Add Category</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <form action="" onSubmit={(e) => formSubmit(e)}>
//               <div className="form-group mb-2">
//                 <p className='mb-1'>Category</p>
//                 <input type="text" name="category" value={formValue && formValue.category} className='form-control' onChange={e => formHandle(e)} placeholder='enter category name' />
//               </div>
//               <div className="form-group text-end ">
//                 <button className='btn btn-primary' type='submit' disabled={loading} >{!loading ? "Save" : "Saving..."}</button>
//               </div>
//             </form>
//           </Modal.Body>
//         </Modal>
//       </CSSTransition>

//       <CSSTransition
//         in={isModalOpen('subcategory')}
//         timeout={2000}
//         classNames="modal-transition"
//         unmountOnExit
//       >
//         <Modal show={isModalOpen('subcategory')} onHide={closeModal} centered>
//           <Modal.Header closeButton>
//             <Modal.Title>Add Subcategory</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <form action="" onSubmit={(e) => formSubmit(e)}>
//               <div className="form-group mb-2">
//                 <p className='mb-1'>Subcateogry</p>
//                 <select name="category" id="" value={formValue && formValue.category} className='form-select' onChange={e => formHandle(e)} required>
//                   <option value="">choose</option>
//                   {categoryalldata && categoryalldata.map(categoryValue => {
//                     return (
//                       <option value={categoryValue.category} key={categoryValue._id}>{categoryValue.category}</option>
//                     )
//                   })}
//                 </select>
//               </div>
//               <div className="form-group mb-2">
//                 <p className='mb-1'>Category</p>
//                 <input type="text" name="subcategory" value={formValue && formValue.subcategory} className='form-control' onChange={e => formHandle(e)} placeholder='enter category name' required />
//               </div>
//               <div className="form-group text-end ">
//                 <button className='btn btn-primary' type='submit' disabled={loading} >{!loading ? "Save" : "Saving..."}</button>
//               </div>
//             </form>
//           </Modal.Body>
//         </Modal>
//       </CSSTransition>

//       <CSSTransition
//         in={isModalOpen('character')}
//         timeout={300}
//         classNames="modal-transition"
//         unmountOnExit
//       >
//         <Modal show={isModalOpen('character')} onHide={closeModal} centered>
//           <Modal.Header closeButton>
//             <Modal.Title>Character</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <form action="" onSubmit={(e) => formSubmit(e)}>
//               <div className="form-group mb-2">
//                 <p className='mb-1'>character</p>
//                 <input type="text" name="character" value={formValue && formValue.character} className='form-control' onChange={e => formHandle(e)} placeholder='enter character name' />
//               </div>
//               <div className="form-group text-end ">
//                 <button className='btn btn-primary' type='submit' disabled={loading} >{!loading ? "Save" : "Saving..."}</button>
//               </div>
//             </form>
//           </Modal.Body>
//         </Modal>
//       </CSSTransition>

//       <CSSTransition
//         in={isModalOpen('subcharacter')}
//         timeout={2000}
//         classNames="modal-transition"
//         unmountOnExit
//       >
//         <Modal show={isModalOpen('subcharacter')} onHide={closeModal} centered>
//           <Modal.Header closeButton>
//             <Modal.Title>Add Subcharacter</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <form action="" onSubmit={(e) => formSubmit(e)}>
//               <div className="form-group mb-2">
//                 <p className='mb-1'>Subcateogry</p>
//                 <select name="character" id="" value={formValue && formValue.character} className='form-select' onChange={e => formHandle(e)} required>
//                   <option value="">choose</option>
//                   {characteralldata && characteralldata.map(characterValue => {
//                     return (
//                       <option value={characterValue.character} key={characterValue._id}>{characterValue.character}</option>
//                     )
//                   })}
//                 </select>
//               </div>
//               <div className="form-group mb-2">
//                 <p className='mb-1'>Category</p>
//                 <input type="text" name="subcharacter" value={formValue && formValue.subcharacter} className='form-control' onChange={e => formHandle(e)} placeholder='enter category name' required />
//               </div>
//               <div className="form-group text-end ">
//                 <button className='btn btn-primary' type='submit' disabled={loading} >{!loading ? "Save" : "Saving..."}</button>
//               </div>
//             </form>
//           </Modal.Body>
//         </Modal>
//       </CSSTransition>


//       <CSSTransition
//         in={isModalOpen('categoryBanner')}
//         timeout={2000}
//         classNames="modal-transition"
//         unmountOnExit
//       >
//         <Modal show={isModalOpen('categoryBanner')} onHide={closeModal} centered>
//           <Modal.Header closeButton>
//             <Modal.Title>Update category Banner Image</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <form action="" onSubmit={(e) => bannerUpdate(e)}>
//               <div className="form-group mb-3">
//                 <p className='mb-1'>Category Banner</p>
//                 <input type="file" accept="image/*" name='bannerImage' className='form-control' placeholder='Upload Banner Image' onChange={e => bannerFileHandle(e)} required />
//                 <small className='text-danger'>{fileErrMsg}</small>
//                 <div className="d-flex justify-content-end gap-2 pt-2">
//                   {uploadLoading && progressValue && <progress className="flex-grow-1" value={progressValue} max="100" style={{ height: "5px" }} />}

//                   {uploadStatus && <small className="fs-10 text-success">{uploadLoading ? `${progressValue} %` : 'success'} </small>}

//                 </div>
//               </div>
//               <div className="form-group text-end ">
//                 <button className='btn btn-primary' type='submit' disabled={fileErrMsg || loading || !formValue.bannerImage} >{!loading ? "Save" : "Saving..."}</button>
//               </div>
//             </form>
//           </Modal.Body>
//         </Modal>
//       </CSSTransition>


//       <CSSTransition
//         in={isModalOpen('characterBanner')}
//         timeout={2000}
//         classNames="modal-transition"
//         unmountOnExit
//       >
//         <Modal show={isModalOpen('characterBanner')} onHide={closeModal} centered>
//           <Modal.Header closeButton>
//             <Modal.Title>Update Image</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <form action="" onSubmit={(e) => bannerUpdate(e)}>
//               <div className="form-group mb-3">
//                 <p className='mb-1'>character </p>
//                 <input type="file" accept="image/*" name='bannerImage' className='form-control' placeholder='Upload Banner Image' onChange={e => bannerFileHandle(e)} required />
//                 <small className='text-danger'>{fileErrMsg}</small>

//                 <div className="d-flex justify-content-end gap-2 pt-2">
//                   {uploadLoading && progressValue && <progress className="flex-grow-1" value={progressValue} max="100" style={{ height: "5px" }} />}

//                   {uploadStatus && <small className="fs-10 text-success">{uploadLoading ? `${progressValue} %` : 'success'} </small>}

//                 </div>
//               </div>
//               <div className="form-group text-end ">
//                 <button className='btn btn-primary' type='submit' disabled={fileErrMsg || loading || !formValue.bannerImage} >{!loading ? "Save" : "Saving..."}</button>
//               </div>
//             </form>
//           </Modal.Body>
//         </Modal>
//       </CSSTransition>


//     </>
//   );
// }


// export default Category













// import { useState } from 'react';
// import { Helmet } from 'react-helmet-async';
// import { useDispatch, useSelector } from 'react-redux';
// import { Modal } from 'react-bootstrap';
// import { CSSTransition } from 'react-transition-group';
// import Swal from 'sweetalert2'
// import axios from 'axios'
// import { Button, Container, Stack, Typography } from '@mui/material';
// import Iconify from '../components/iconify';
// import { Url, awsFileUrl } from '../url/url';
// import { categorydata } from '../redux/slice/category'
// import { subcategorydata } from '../redux/slice/subcategory'
// import 'bootstrap/dist/css/bootstrap.min.css';

// const Category = () => {
//     const dispatch = useDispatch()
//     const categoryalldata = useSelector(store => store.category.data)
//     const subcategoryalldata = useSelector(store => store.subcategory.data)

//     const [activeModal, setActiveModal] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [formValue, setFormValue] = useState({});
//     const [pathValue, setPathValue] = useState({});
//     const [fileErrMsg, setFileErrMsg] = useState("")
//     const [uploadLoading, setUploadLoading] = useState(false);
//     const [progressValue, setProgressValue] = useState(0);
//     const [uploadStatus, setUploadStatus] = useState(false);

//     const openModal = (modalName, path, data = null) => {
//         setActiveModal(modalName);
//         setPathValue(path)
//         if (data && data !== null) {
//             setFormValue(data)
//         }
//     }

//     const closeModal = () => {
//         setActiveModal(null);
//         setFormValue({})
//     };

//     const isModalOpen = (modalName) => activeModal === modalName;

//     const formHandle = (e) => {
//         const name = e.target.name
//         const value = e.target.value
//         const lowerValue = value.toLowerCase();
//         setFormValue({ ...formValue, [name]: lowerValue })
//     }

//     const fileHandle = (e) => {
//         setFileErrMsg('')
//         const name = e.target.name
//         const file = e.target.files[0]
//         if (file.size < 100000) {
//             setFormValue({ ...formValue, [name]: file })
//         } else {
//             setFileErrMsg('Please keep file size less than 100 kb')
//         }
//     }

//     const deleteFunc = async (path) => {
//         Swal.fire({
//             title: 'Are you sure?',
//             text: "You want delete this?",
//             icon: 'warning',
//             showCancelButton: true,
//             confirmButtonColor: '#3085d6',
//             cancelButtonColor: '#d33',
//             confirmButtonText: 'Yes, delete it!'
//         }).then(async (result) => {
//             if (result.isConfirmed) {
//                 await axios.delete(`${Url}${path}`).then(() => {
//                     Swal.fire({ position: 'top-end', icon: 'success', title: 'Deleted Successfully', showConfirmButton: false, timer: 1000 })
//                     dispatch(categorydata())
//                     dispatch(subcategorydata())
//                 }).catch(() => {
//                     Swal.fire({ position: 'top-end', icon: 'error', title: 'Something went wrong', showConfirmButton: false, timer: 1500 })
//                 })
//             }
//         })
//     }

//     const formSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true)
//         try {
//             await axios.post(`${Url}${pathValue}`, formValue)
//             Swal.fire({ position: 'top-end', icon: 'success', title: 'Created Successfully', showConfirmButton: false, timer: 1500 })
//             setFormValue({})
//             setPathValue('')
//             dispatch(categorydata())
//             dispatch(subcategorydata())
//             closeModal()
//         } catch (error) {
//             console.log(error);
//         }
//         setLoading(false)
//     }

//     const bannerUpdate = async (e) => {
//         e.preventDefault();
//         setLoading(true)
//         try {
//             await axios.post(`${Url}${pathValue}`, formValue)
//             Swal.fire({ position: 'top-end', icon: 'success', title: 'Updated Successfully', showConfirmButton: false, timer: 1500 })
//             setFormValue({})
//             setPathValue('')
//             dispatch(categorydata())
//             dispatch(subcategorydata())
//             closeModal()
//         } catch (error) {
//             console.log(error);
//         }
//         setLoading(false)
//     }

//     const bannerFileHandle = async (e) => {
//         const file = e.target.files[0]
//         const name = e.target.name
//         setUploadLoading(true)
//         const targetApi = activeModal === "categoryBanner" ? 'category' : undefined;
//         setFileErrMsg('')
//         try {
//             if (file) {
//                 if (file.size < 1000000 && targetApi) {
//                     const response = await axios.post(`${Url}/api/createPresignedUrl/${targetApi}`, { fileName: file.name, fileType: file.type })
//                     if (response.status === 200) {
//                         const { preSignedUrl, key } = response?.data
//                         const responseFileSave = await axios.put(preSignedUrl, file, {
//                             onUploadProgress: (progressEvent) => {
//                                 const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                                 setProgressValue(progress)
//                             },
//                         })
//                         if (responseFileSave.status === 200) {
//                             const fileUrl = `${awsFileUrl}/${key}`
//                             setFormValue({ ...formValue, [name]: fileUrl })
//                             setUploadStatus(true)
//                             setUploadLoading(false)
//                             setProgressValue(0)
//                         } else {
//                             setUploadLoading(false)
//                             setProgressValue(0)
//                             setUploadStatus(false)
//                         }
//                         setUploadLoading(false)
//                     }
//                     setUploadLoading(false)
//                 } else {
//                     setFileErrMsg('Please keep file size less than 1 MB')
//                 }
//             }
//         } catch (error) {
//             console.log(error);
//             setUploadLoading(false)
//         }
//         setUploadLoading(false)
//     }

//     return (
//         <>
//             <Helmet><title> Category </title></Helmet>

//             <Container className='mb-3 border-bottom pb-3 border-top pt-3'>
//                 <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
//                     <Typography variant="h4" gutterBottom>Category</Typography>
//                     <div className='d-flex align-items-center gap-3'>
//                         <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}
//                             onClick={() => openModal('category', '/api/category/create')}>
//                             Add New Category
//                         </Button>
//                         {categoryalldata.length > 0 &&
//                             <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}
//                                 onClick={() => openModal('subcategory', '/api/subcategory/create')}>
//                                 Add New SubCategory
//                             </Button>}
//                     </div>
//                 </Stack>

//                 <div className="subcategory-wrap mb-4">
//                     <div className="d-flex">
//                         {categoryalldata.length > 0 ? categoryalldata.map((categoryValue) => (
//                             <div key={categoryValue._id} className='border'>
//                                 <div className="border-bottom">
//                                     <div className="d-flex align-items-center justify-content-between bg-light gap-3 px-3 py-2">
//                                         <h5 className='text-primary text-capitalize mb-0'>{categoryValue.category}</h5>
//                                         <div className="d-flex align-items-center gap-2">
//                                             <button className="btn btn-sm"
//                                                 onClick={() => openModal('categoryBanner', `/api/category/banner/${categoryValue._id}`)}>
//                                                 <i className="fa-regular fa-image text-success fa-lg" />
//                                             </button>
//                                             {/* ✅ subcategory filter ab _id se */}
//                                             {subcategoryalldata &&
//                                                 subcategoryalldata.filter(data => data.category?._id === categoryValue._id).length <= 0 ?
//                                                 <button className='border-0 bg-transparent'
//                                                     onClick={() => deleteFunc(`/api/category/delete/${categoryValue._id}`)}>
//                                                     <i className="fa-solid fa-trash text-danger fa-sm" />
//                                                 </button> : null}
//                                         </div>
//                                     </div>
//                                     {categoryValue.imageUrl &&
//                                         <div className='px-3 pb-2'>
//                                             <img src={categoryValue.imageUrl} alt="category" style={{ width: "250px" }} />
//                                         </div>}
//                                 </div>

//                                 <div>
//                                     {/* ✅ _id se filter */}
//                                     {subcategoryalldata &&
//                                         subcategoryalldata.filter(data => data.category?._id === categoryValue._id)
//                                             .map(subcategoryValue => (
//                                                 <div key={subcategoryValue._id}
//                                                     className='d-flex gap-4 justify-content-between py-2 align-items-center px-3 shadow-sm'>
//                                                     <p className='mb-0 text-capitalize'>{subcategoryValue.subcategory}</p>
//                                                     <div className="d-flex align-items-center gap-2">
//                                                         <button className='btn py-0 btn-sm btn-warning'
//                                                             onClick={() => openModal(
//                                                                 'subcategory',
//                                                                 `/api/subcategory/update/${subcategoryValue._id}`,
//                                                                 {
//                                                                     // ✅ edit ke time _id pass karo
//                                                                     category: subcategoryValue.category._id,
//                                                                     subcategory: subcategoryValue.subcategory
//                                                                 }
//                                                             )}>edit</button>
//                                                         <button className='btn py-0 btn-sm btn-danger'
//                                                             onClick={() => deleteFunc(`/api/subcategory/delete/${subcategoryValue._id}`)}>
//                                                             remove
//                                                         </button>
//                                                     </div>
//                                                 </div>
//                                             ))}
//                                 </div>
//                             </div>
//                         )) : <div className='text-center w-100'>NO Category & Subcategory</div>}
//                     </div>
//                 </div>
//             </Container>

//             {/* Category Modal */}
//             <CSSTransition in={isModalOpen('category')} timeout={300} classNames="modal-transition" unmountOnExit>
//                 <Modal show={isModalOpen('category')} onHide={closeModal} centered>
//                     <Modal.Header closeButton>
//                         <Modal.Title>Add Category</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body>
//                         <form onSubmit={formSubmit}>
//                             <div className="form-group mb-2">
//                                 <p className='mb-1'>Category</p>
//                                 <input type="text" name="category" value={formValue?.category || ''} className='form-control'
//                                     onChange={formHandle} placeholder='enter category name' required />
//                             </div>
//                             <div className="form-group text-end">
//                                 <button className='btn btn-primary' type='submit' disabled={loading}>
//                                     {!loading ? "Save" : "Saving..."}
//                                 </button>
//                             </div>
//                         </form>
//                     </Modal.Body>
//                 </Modal>
//             </CSSTransition>

//             {/* Subcategory Modal */}
//             <CSSTransition in={isModalOpen('subcategory')} timeout={300} classNames="modal-transition" unmountOnExit>
//                 <Modal show={isModalOpen('subcategory')} onHide={closeModal} centered>
//                     <Modal.Header closeButton>
//                         <Modal.Title>Add / Edit Subcategory</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body>
//                         <form onSubmit={formSubmit}>
//                             <div className="form-group mb-2">
//                                 <p className='mb-1'>Select Category</p>
//                                 {/* ✅ value mein _id bhej rahe hain */}
//                                 <select name="category" value={formValue?.category || ''} className='form-select'
//                                     onChange={formHandle} required>
//                                     <option value="">choose</option>
//                                     {categoryalldata && categoryalldata.map(categoryValue => (
//                                         <option value={categoryValue._id} key={categoryValue._id}>
//                                             {categoryValue.category}
//                                         </option>
//                                     ))}
//                                 </select>
//                             </div>
//                             <div className="form-group mb-2">
//                                 <p className='mb-1'>Subcategory Name</p>
//                                 <input type="text" name="subcategory" value={formValue?.subcategory || ''} className='form-control'
//                                     onChange={formHandle} placeholder='enter subcategory name' required />
//                             </div>
//                             <div className="form-group text-end">
//                                 <button className='btn btn-primary' type='submit' disabled={loading}>
//                                     {!loading ? "Save" : "Saving..."}
//                                 </button>
//                             </div>
//                         </form>
//                     </Modal.Body>
//                 </Modal>
//             </CSSTransition>

//             {/* Category Banner Modal */}
//             <CSSTransition in={isModalOpen('categoryBanner')} timeout={300} classNames="modal-transition" unmountOnExit>
//                 <Modal show={isModalOpen('categoryBanner')} onHide={closeModal} centered>
//                     <Modal.Header closeButton>
//                         <Modal.Title>Update Category Banner Image</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body>
//                         <form onSubmit={bannerUpdate}>
//                             <div className="form-group mb-3">
//                                 <p className='mb-1'>Category Banner</p>
//                                 <input type="file" accept="image/*" name='bannerImage' className='form-control'
//                                     onChange={bannerFileHandle} required />
//                                 <small className='text-danger'>{fileErrMsg}</small>
//                                 <div className="d-flex justify-content-end gap-2 pt-2">
//                                     {uploadLoading && progressValue > 0 &&
//                                         <progress className="flex-grow-1" value={progressValue} max="100" style={{ height: "5px" }} />}
//                                     {uploadStatus &&
//                                         <small className="text-success">
//                                             {uploadLoading ? `${progressValue}%` : 'Uploaded ✓'}
//                                         </small>}
//                                 </div>
//                             </div>
//                             <div className="form-group text-end">
//                                 <button className='btn btn-primary' type='submit'
//                                     disabled={!!fileErrMsg || loading || !formValue.bannerImage}>
//                                     {!loading ? "Save" : "Saving..."}
//                                 </button>
//                             </div>
//                         </form>
//                     </Modal.Body>
//                 </Modal>
//             </CSSTransition>
//         </>
//     );
// }

// export default Category








// import { useState } from 'react';
// import { Helmet } from 'react-helmet-async';
// import { useDispatch, useSelector } from 'react-redux';
// import { Modal } from 'react-bootstrap';
// import { CSSTransition } from 'react-transition-group';
// import Swal from 'sweetalert2';
// import axios from 'axios';
// import {
//   Button, Container, Stack, Typography, Box, Chip, IconButton, Card, CardMedia, CardContent, Tooltip
// } from '@mui/material';
// import Iconify from '../components/iconify';
// import { Url, awsFileUrl } from '../url/url';
// import { categorydata } from '../redux/slice/category';
// import { subcategorydata } from '../redux/slice/subcategory';
// import 'bootstrap/dist/css/bootstrap.min.css';

// const Category = () => {
//   const dispatch = useDispatch();
//   const categoryalldata = useSelector((store) => store.category.data);
//   const subcategoryalldata = useSelector((store) => store.subcategory.data);

//   const [activeModal, setActiveModal] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [formValue, setFormValue] = useState({});
//   const [pathValue, setPathValue] = useState({});
//   const [fileErrMsg, setFileErrMsg] = useState('');
//   const [uploadLoading, setUploadLoading] = useState(false);
//   const [progressValue, setProgressValue] = useState(0);
//   const [uploadStatus, setUploadStatus] = useState(false);

//   const openModal = (modalName, path, data = null) => {
//     setActiveModal(modalName);
//     setPathValue(path);
//     if (data && data !== null) setFormValue(data);
//   };

//   const closeModal = () => { setActiveModal(null); setFormValue({}); };
//   const isModalOpen = (modalName) => activeModal === modalName;

//   const formHandle = (e) => {
//     const { name, value } = e.target;
//     setFormValue({ ...formValue, [name]: value.toLowerCase() });
//   };

//   const deleteFunc = async (path) => {
//     Swal.fire({
//       title: 'Are you sure?', text: 'You want delete this?', icon: 'warning',
//       showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         await axios.delete(`${Url}${path}`).then(() => {
//           Swal.fire({ position: 'top-end', icon: 'success', title: 'Deleted Successfully', showConfirmButton: false, timer: 1000 });
//           dispatch(categorydata()); dispatch(subcategorydata());
//         }).catch(() => {
//           Swal.fire({ position: 'top-end', icon: 'error', title: 'Something went wrong', showConfirmButton: false, timer: 1500 });
//         });
//       }
//     });
//   };

//   const formSubmit = async (e) => {
//     e.preventDefault(); setLoading(true);
//     try {
//       await axios.post(`${Url}${pathValue}`, formValue);
//       Swal.fire({ position: 'top-end', icon: 'success', title: 'Created Successfully', showConfirmButton: false, timer: 1500 });
//       setFormValue({}); setPathValue('');
//       dispatch(categorydata()); dispatch(subcategorydata()); closeModal();
//     } catch (error) { console.log(error); }
//     setLoading(false);
//   };

//   const bannerUpdate = async (e) => {
//     e.preventDefault(); setLoading(true);
//     try {
//       await axios.post(`${Url}${pathValue}`, formValue);
//       Swal.fire({ position: 'top-end', icon: 'success', title: 'Updated Successfully', showConfirmButton: false, timer: 1500 });
//       setFormValue({}); setPathValue('');
//       dispatch(categorydata()); dispatch(subcategorydata()); closeModal();
//     } catch (error) { console.log(error); }
//     setLoading(false);
//   };

//   const bannerFileHandle = async (e) => {
//     const file = e.target.files[0];
//     const name = e.target.name;
//     setUploadLoading(true);
//     const targetApi = activeModal === 'categoryBanner' ? 'category' : undefined;
//     setFileErrMsg('');
//     try {
//       if (file) {
//         if (file.size < 1000000 && targetApi) {
//           const response = await axios.post(`${Url}/api/createPresignedUrl/${targetApi}`, { fileName: file.name, fileType: file.type });
//           if (response.status === 200) {
//             const { preSignedUrl, key } = response?.data;
//             const responseFileSave = await axios.put(preSignedUrl, file, {
//               onUploadProgress: (progressEvent) => {
//                 setProgressValue(Math.round((progressEvent.loaded * 100) / progressEvent.total));
//               },
//             });
//             if (responseFileSave.status === 200) {
//               setFormValue({ ...formValue, [name]: `${awsFileUrl}/${key}` });
//               setUploadStatus(true); setUploadLoading(false); setProgressValue(0);
//             } else { setUploadLoading(false); setProgressValue(0); setUploadStatus(false); }
//           }
//         } else { setFileErrMsg('Please keep file size less than 1 MB'); }
//       }
//     } catch (error) { console.log(error); }
//     setUploadLoading(false);
//   };

//   return (
//     <>
//       <Helmet><title>Category</title></Helmet>

//       <Container maxWidth="xl">
//         {/* Header */}
//         <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 4 }}>
//           <Box>
//             <Typography variant="h4" fontWeight={500}>Category</Typography>
//             <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
//               Manage your product categories and subcategories
//             </Typography>
//           </Box>
//           <Stack direction="row" spacing={1.5}>
//             <Button
//               variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}
//               onClick={() => openModal('category', '/api/category/create')}
//               sx={{ borderRadius: 2 }}
//             >
//               Add Category
//             </Button>
//             {categoryalldata.length > 0 && (
//               <Button
//                 variant="outlined" startIcon={<Iconify icon="eva:plus-fill" />}
//                 onClick={() => openModal('subcategory', '/api/subcategory/create')}
//                 sx={{ borderRadius: 2 }}
//               >
//                 Add SubCategory
//               </Button>
//             )}
//           </Stack>
//         </Stack>

//         {/* Category Cards Grid */}
//         {categoryalldata.length > 0 ? (
//           <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 3 }}>
//             {categoryalldata.map((categoryValue) => {
//               const subcategories = subcategoryalldata?.filter(
//                 (d) => d.category?._id === categoryValue._id
//               );
//               const canDelete = subcategories.length === 0;

//               return (
//                 <Card
//                   key={categoryValue._id}
//                   sx={{
//                     borderRadius: 3,
//                     border: '1px solid',
//                     borderColor: 'divider',
//                     boxShadow: 'none',
//                     overflow: 'hidden',
//                     transition: 'box-shadow 0.2s',
//                     '&:hover': { boxShadow: 4 },
//                   }}
//                 >
//                   {/* Card Header */}
//                   <Box sx={{
//                     px: 2.5, py: 1.5,
//                     display: 'flex', alignItems: 'center', justifyContent: 'space-between',
//                     borderBottom: '1px solid', borderColor: 'divider',
//                     bgcolor: 'background.neutral',
//                   }}>
//                     <Typography variant="subtitle1" fontWeight={600} textTransform="capitalize" color="primary.main">
//                       {categoryValue.category}
//                     </Typography>
//                     <Stack direction="row" spacing={0.5}>
//                       <Tooltip title="Update banner image">
//                         <IconButton
//                           size="small"
//                           onClick={() => openModal('categoryBanner', `/api/category/banner/${categoryValue._id}`)}
//                           sx={{ color: 'success.main', bgcolor: 'success.lighter', borderRadius: 1.5, '&:hover': { bgcolor: 'success.light' } }}
//                         >
//                           <Iconify icon="eva:image-fill" width={18} />
//                         </IconButton>
//                       </Tooltip>
//                       {canDelete && (
//                         <Tooltip title="Delete category">
//                           <IconButton
//                             size="small"
//                             onClick={() => deleteFunc(`/api/category/delete/${categoryValue._id}`)}
//                             sx={{ color: 'error.main', bgcolor: 'error.lighter', borderRadius: 1.5, '&:hover': { bgcolor: 'error.light' } }}
//                           >
//                             <Iconify icon="eva:trash-2-fill" width={18} />
//                           </IconButton>
//                         </Tooltip>
//                       )}
//                     </Stack>
//                   </Box>

//                   {/* Category Image */}
//                   {categoryValue.imageUrl && (
//                     <CardMedia
//                       component="img"
//                       image={categoryValue.imageUrl}
//                       alt={categoryValue.category}
//                       sx={{ height: 180, objectFit: 'cover' }}
//                     />
//                   )}

//                   {/* Subcategories */}
//                   <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
//                     {subcategories.length > 0 ? (
//                       <Stack spacing={1}>
//                         <Typography variant="caption" color="text.secondary" fontWeight={600} textTransform="uppercase" letterSpacing={0.8}>
//                           Subcategories ({subcategories.length})
//                         </Typography>
//                         {subcategories.map((sub) => (
//                           <Box
//                             key={sub._id}
//                             sx={{
//                               display: 'flex', alignItems: 'center', justifyContent: 'space-between',
//                               px: 1.5, py: 1,
//                               borderRadius: 2,
//                               border: '1px solid', borderColor: 'divider',
//                               bgcolor: 'background.paper',
//                             }}
//                           >
//                             <Typography variant="body2" textTransform="capitalize" fontWeight={500}>
//                               {sub.subcategory}
//                             </Typography>
//                             <Stack direction="row" spacing={0.5}>
//                               <Chip
//                                 label="Edit"
//                                 size="small"
//                                 color="warning"
//                                 onClick={() => openModal('subcategory', `/api/subcategory/update/${sub._id}`, {
//                                   category: sub.category._id,
//                                   subcategory: sub.subcategory,
//                                 })}
//                                 sx={{ fontSize: 11, height: 24, cursor: 'pointer', borderRadius: 1 }}
//                               />
//                               <Chip
//                                 label="Remove"
//                                 size="small"
//                                 color="error"
//                                 onClick={() => deleteFunc(`/api/subcategory/delete/${sub._id}`)}
//                                 sx={{ fontSize: 11, height: 24, cursor: 'pointer', borderRadius: 1 }}
//                               />
//                             </Stack>
//                           </Box>
//                         ))}
//                       </Stack>
//                     ) : (
//                       <Box sx={{ textAlign: 'center', py: 1 }}>
//                         <Typography variant="body2" color="text.disabled">No subcategories yet</Typography>
//                       </Box>
//                     )}
//                   </CardContent>
//                 </Card>
//               );
//             })}
//           </Box>
//         ) : (
//           <Box sx={{ textAlign: 'center', py: 10 }}>
//             <Iconify icon="eva:layers-outline" width={48} sx={{ color: 'text.disabled', mb: 2 }} />
//             <Typography variant="h6" color="text.disabled">No categories found</Typography>
//             <Typography variant="body2" color="text.disabled">Click "Add Category" to get started</Typography>
//           </Box>
//         )}
//       </Container>

//       {/* Category Modal */}
//       <CSSTransition in={isModalOpen('category')} timeout={300} classNames="modal-transition" unmountOnExit>
//         <Modal show={isModalOpen('category')} onHide={closeModal} centered>
//           <Modal.Header closeButton><Modal.Title>Add Category</Modal.Title></Modal.Header>
//           <Modal.Body>
//             <form onSubmit={formSubmit}>
//               <div className="form-group mb-3">
//                 <p className="mb-1">Category Name</p>
//                 <input type="text" name="category" value={formValue?.category || ''} className="form-control"
//                   onChange={formHandle} placeholder="Enter category name" required />
//               </div>
//               <div className="form-group text-end">
//                 <button className="btn btn-primary" type="submit" disabled={loading}>
//                   {!loading ? 'Save' : 'Saving...'}
//                 </button>
//               </div>
//             </form>
//           </Modal.Body>
//         </Modal>
//       </CSSTransition>

//       {/* Subcategory Modal */}
//       <CSSTransition in={isModalOpen('subcategory')} timeout={300} classNames="modal-transition" unmountOnExit>
//         <Modal show={isModalOpen('subcategory')} onHide={closeModal} centered>
//           <Modal.Header closeButton><Modal.Title>Add / Edit Subcategory</Modal.Title></Modal.Header>
//           <Modal.Body>
//             <form onSubmit={formSubmit}>
//               <div className="form-group mb-3">
//                 <p className="mb-1">Select Category</p>
//                 <select name="category" value={formValue?.category || ''} className="form-select" onChange={formHandle} required>
//                   <option value="">Choose category</option>
//                   {categoryalldata && categoryalldata.map((cat) => (
//                     <option value={cat._id} key={cat._id}>{cat.category}</option>
//                   ))}
//                 </select>
//               </div>
//               <div className="form-group mb-3">
//                 <p className="mb-1">Subcategory Name</p>
//                 <input type="text" name="subcategory" value={formValue?.subcategory || ''} className="form-control"
//                   onChange={formHandle} placeholder="Enter subcategory name" required />
//               </div>
//               <div className="form-group text-end">
//                 <button className="btn btn-primary" type="submit" disabled={loading}>
//                   {!loading ? 'Save' : 'Saving...'}
//                 </button>
//               </div>
//             </form>
//           </Modal.Body>
//         </Modal>
//       </CSSTransition>

//       {/* Category Banner Modal */}
//       <CSSTransition in={isModalOpen('categoryBanner')} timeout={300} classNames="modal-transition" unmountOnExit>
//         <Modal show={isModalOpen('categoryBanner')} onHide={closeModal} centered>
//           <Modal.Header closeButton><Modal.Title>Update Category Banner</Modal.Title></Modal.Header>
//           <Modal.Body>
//             <form onSubmit={bannerUpdate}>
//               <div className="form-group mb-3">
//                 <p className="mb-1">Category Banner Image</p>
//                 <input type="file" accept="image/*" name="bannerImage" className="form-control"
//                   onChange={bannerFileHandle} required />
//                 <small className="text-danger">{fileErrMsg}</small>
//                 <div className="d-flex justify-content-end gap-2 pt-2">
//                   {uploadLoading && progressValue > 0 && (
//                     <progress className="flex-grow-1" value={progressValue} max="100" style={{ height: '5px' }} />
//                   )}
//                   {uploadStatus && (
//                     <small className="text-success">{uploadLoading ? `${progressValue}%` : 'Uploaded ✓'}</small>
//                   )}
//                 </div>
//               </div>
//               <div className="form-group text-end">
//                 <button className="btn btn-primary" type="submit"
//                   disabled={!!fileErrMsg || loading || !formValue.bannerImage}>
//                   {!loading ? 'Save' : 'Saving...'}
//                 </button>
//               </div>
//             </form>
//           </Modal.Body>
//         </Modal>
//       </CSSTransition>
//     </>
//   );
// };

// export default Category;











import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { CSSTransition } from 'react-transition-group';
import Swal from 'sweetalert2';
import axios from 'axios';
import {
  Button, Container, Stack, Typography, Box, Chip, IconButton, Card, CardMedia, CardContent, Tooltip, Divider
} from '@mui/material';
import Iconify from '../components/iconify';
import { Url, awsFileUrl } from '../url/url';
import { maincategorydata } from '../redux/slice/Maincategory';
import { categorydata } from '../redux/slice/category';
import { subcategorydata } from '../redux/slice/subcategory';
import 'bootstrap/dist/css/bootstrap.min.css';

const Category = () => {
  const dispatch = useDispatch();
  const mainCategoryAllData = useSelector((store) => store.maincategory.data);
  const categoryalldata = useSelector((store) => store.category.data);
  const subcategoryalldata = useSelector((store) => store.subcategory.data);

  const [activeModal, setActiveModal] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formValue, setFormValue] = useState({});
  const [pathValue, setPathValue] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [fileErrMsg, setFileErrMsg] = useState('');
  const [uploadLoading, setUploadLoading] = useState(false);
  const [progressValue, setProgressValue] = useState(0);
  const [uploadStatus, setUploadStatus] = useState(false);

  useEffect(() => {
    dispatch(maincategorydata());
    dispatch(categorydata());
    dispatch(subcategorydata());
  }, [dispatch]);

  // editMode=true => update API (POST /update/:id), false => create API
  const openModal = (modalName, path, data = null, editMode = false) => {
    setActiveModal(modalName);
    setPathValue(path);
    setIsEditMode(editMode);
    if (data && data !== null) setFormValue(data);
  };

  const closeModal = () => { setActiveModal(null); setFormValue({}); setIsEditMode(false); };
  const isModalOpen = (modalName) => activeModal === modalName;

  const formHandle = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formValue, [name]: value.toLowerCase() });
  };

  // mainCategory select dropdown ke liye — ID hai, lowercase nahi karna
  const selectHandle = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formValue, [name]: value });
  };

  const deleteFunc = async (path) => {
    Swal.fire({
      title: 'Are you sure?', text: 'You want delete this?', icon: 'warning',
      showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        await axios.delete(`${Url}${path}`).then(() => {
          Swal.fire({ position: 'top-end', icon: 'success', title: 'Deleted Successfully', showConfirmButton: false, timer: 1000 });
          dispatch(maincategorydata()); dispatch(categorydata()); dispatch(subcategorydata());
        }).catch(() => {
          Swal.fire({ position: 'top-end', icon: 'error', title: 'Something went wrong', showConfirmButton: false, timer: 1500 });
        });
      }
    });
  };

  // create aur update dono isi se ho jate hain — path already decide karta hai kaunsa hit hoga
  const formSubmit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      await axios.post(`${Url}${pathValue}`, formValue);
      Swal.fire({
        position: 'top-end', icon: 'success',
        title: isEditMode ? 'Updated Successfully' : 'Created Successfully',
        showConfirmButton: false, timer: 1500
      });
      setFormValue({}); setPathValue('');
      dispatch(maincategorydata()); dispatch(categorydata()); dispatch(subcategorydata()); closeModal();
    } catch (error) { console.log(error); }
    setLoading(false);
  };

  const bannerUpdate = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      await axios.post(`${Url}${pathValue}`, formValue);
      Swal.fire({ position: 'top-end', icon: 'success', title: 'Updated Successfully', showConfirmButton: false, timer: 1500 });
      setFormValue({}); setPathValue('');
      dispatch(categorydata()); dispatch(subcategorydata()); closeModal();
    } catch (error) { console.log(error); }
    setLoading(false);
  };

  const bannerFileHandle = async (e) => {
    const file = e.target.files[0];
    const name = e.target.name;
    setUploadLoading(true);
    const targetApi = activeModal === 'categoryBanner' ? 'category' : undefined;
    setFileErrMsg('');
    try {
      if (file) {
        if (file.size < 1000000 && targetApi) {
          const response = await axios.post(`${Url}/api/createPresignedUrl/${targetApi}`, { fileName: file.name, fileType: file.type });
          if (response.status === 200) {
            const { preSignedUrl, key } = response?.data;
            const responseFileSave = await axios.put(preSignedUrl, file, {
              onUploadProgress: (progressEvent) => {
                setProgressValue(Math.round((progressEvent.loaded * 100) / progressEvent.total));
              },
            });
            if (responseFileSave.status === 200) {
              setFormValue({ ...formValue, [name]: `${awsFileUrl}/${key}` });
              setUploadStatus(true); setUploadLoading(false); setProgressValue(0);
            } else { setUploadLoading(false); setProgressValue(0); setUploadStatus(false); }
          }
        } else { setFileErrMsg('Please keep file size less than 1 MB'); }
      }
    } catch (error) { console.log(error); }
    setUploadLoading(false);
  };

  return (
    <>
      <Helmet><title>Category</title></Helmet>

      <Container maxWidth="xl">
        {/* Header */}
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 4 }}>
          <Box>
            <Typography variant="h4" fontWeight={500}>Category</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              Manage your shop, categories and subcategories
            </Typography>
          </Box>
          <Stack direction="row" spacing={1.5}>
            <Button
              variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}
              onClick={() => openModal('mainCategory', '/api/maincategory/create')}
              sx={{ borderRadius: 2 }}
            >
              Add Shop
            </Button>
            {mainCategoryAllData?.length > 0 && (
              <Button
                variant="outlined" startIcon={<Iconify icon="eva:plus-fill" />}
                onClick={() => openModal('category', '/api/category/create')}
                sx={{ borderRadius: 2 }}
              >
                Add Category
              </Button>
            )}
            {categoryalldata?.length > 0 && (
              <Button
                variant="outlined" startIcon={<Iconify icon="eva:plus-fill" />}
                onClick={() => openModal('subcategory', '/api/subcategory/create')}
                sx={{ borderRadius: 2 }}
              >
                Add SubCategory
              </Button>
            )}
          </Stack>
        </Stack>

        {/* ---------- MAIN CATEGORY (Shop For Pets / Shop For Human) ---------- */}
        {mainCategoryAllData?.length > 0 ? (
          <Stack spacing={4}>
            {mainCategoryAllData.map((mainCat) => {
              const categoriesUnderMain = categoryalldata?.filter((cat) => {
                const catMainId = cat.mainCategory?._id || cat.mainCategory;
                return catMainId === mainCat._id;
              });

              return (
                <Box key={mainCat._id}>
                  {/* Shop header */}
                  <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
                    <Stack direction="row" alignItems="center" spacing={1.5}>
                      <Iconify icon="eva:shopping-bag-fill" width={22} sx={{ color: 'primary.main' }} />
                      <Typography variant="h5" fontWeight={600} textTransform="capitalize">
                        {mainCat.mainCategory}
                      </Typography>
                      <Chip label={`${categoriesUnderMain.length} categories`} size="small" sx={{ borderRadius: 1 }} />
                    </Stack>
                    <Stack direction="row" spacing={0.5}>
                      <Tooltip title="Edit shop name">
                        <IconButton
                          size="small"
                          onClick={() => openModal(
                            'mainCategory',
                            `/api/maincategory/update/${mainCat._id}`,
                            { mainCategory: mainCat.mainCategory },
                            true
                          )}
                          sx={{ color: 'warning.main', bgcolor: 'warning.lighter', borderRadius: 1.5, '&:hover': { bgcolor: 'warning.light' } }}
                        >
                          <Iconify icon="eva:edit-2-fill" width={18} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete shop (only if empty of categories)">
                        <IconButton
                          size="small"
                          disabled={categoriesUnderMain.length > 0}
                          onClick={() => deleteFunc(`/api/maincategory/delete/${mainCat._id}`)}
                          sx={{ color: 'error.main', bgcolor: 'error.lighter', borderRadius: 1.5, '&:hover': { bgcolor: 'error.light' } }}
                        >
                          <Iconify icon="eva:trash-2-fill" width={18} />
                        </IconButton>
                      </Tooltip>
                    </Stack>
                  </Stack>

                  {/* Categories under this main category */}
                  {categoriesUnderMain.length > 0 ? (
                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 3 }}>
                      {categoriesUnderMain.map((categoryValue) => {
                        const subcategories = subcategoryalldata?.filter(
                          (d) => d.category?._id === categoryValue._id
                        );
                        const canDelete = subcategories.length === 0;

                        return (
                          <Card
                            key={categoryValue._id}
                            sx={{
                              borderRadius: 3,
                              border: '1px solid',
                              borderColor: 'divider',
                              boxShadow: 'none',
                              overflow: 'hidden',
                              transition: 'box-shadow 0.2s',
                              '&:hover': { boxShadow: 4 },
                            }}
                          >
                            {/* Card Header */}
                            <Box sx={{
                              px: 2.5, py: 1.5,
                              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                              borderBottom: '1px solid', borderColor: 'divider',
                              bgcolor: 'background.neutral',
                            }}>
                              <Typography variant="subtitle1" fontWeight={600} textTransform="capitalize" color="primary.main">
                                {categoryValue.category}
                              </Typography>
                              <Stack direction="row" spacing={0.5}>
                                <Tooltip title="Edit category name">
                                  <IconButton
                                    size="small"
                                    onClick={() => openModal(
                                      'category',
                                      `/api/category/update/${categoryValue._id}`,
                                      {
                                        mainCategory: categoryValue.mainCategory?._id || categoryValue.mainCategory,
                                        category: categoryValue.category,
                                      },
                                      true
                                    )}
                                    sx={{ color: 'warning.main', bgcolor: 'warning.lighter', borderRadius: 1.5, '&:hover': { bgcolor: 'warning.light' } }}
                                  >
                                    <Iconify icon="eva:edit-2-fill" width={18} />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Update banner image">
                                  <IconButton
                                    size="small"
                                    onClick={() => openModal('categoryBanner', `/api/category/banner/${categoryValue._id}`)}
                                    sx={{ color: 'success.main', bgcolor: 'success.lighter', borderRadius: 1.5, '&:hover': { bgcolor: 'success.light' } }}
                                  >
                                    <Iconify icon="eva:image-fill" width={18} />
                                  </IconButton>
                                </Tooltip>
                                {canDelete && (
                                  <Tooltip title="Delete category">
                                    <IconButton
                                      size="small"
                                      onClick={() => deleteFunc(`/api/category/delete/${categoryValue._id}`)}
                                      sx={{ color: 'error.main', bgcolor: 'error.lighter', borderRadius: 1.5, '&:hover': { bgcolor: 'error.light' } }}
                                    >
                                      <Iconify icon="eva:trash-2-fill" width={18} />
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </Stack>
                            </Box>

                            {/* Category Image */}
                            {categoryValue.imageUrl && (
                              <CardMedia
                                component="img"
                                image={categoryValue.imageUrl}
                                alt={categoryValue.category}
                                sx={{ height: 180, objectFit: 'cover' }}
                              />
                            )}

                            {/* Subcategories */}
                            <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                              {subcategories.length > 0 ? (
                                <Stack spacing={1}>
                                  <Typography variant="caption" color="text.secondary" fontWeight={600} textTransform="uppercase" letterSpacing={0.8}>
                                    Subcategories ({subcategories.length})
                                  </Typography>
                                  {subcategories.map((sub) => (
                                    <Box
                                      key={sub._id}
                                      sx={{
                                        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                        px: 1.5, py: 1,
                                        borderRadius: 2,
                                        border: '1px solid', borderColor: 'divider',
                                        bgcolor: 'background.paper',
                                      }}
                                    >
                                      <Typography variant="body2" textTransform="capitalize" fontWeight={500}>
                                        {sub.subcategory}
                                      </Typography>
                                      <Stack direction="row" spacing={0.5}>
                                        <Chip
                                          label="Edit"
                                          size="small"
                                          color="warning"
                                          onClick={() => openModal(
                                            'subcategory',
                                            `/api/subcategory/update/${sub._id}`,
                                            {
                                              category: sub.category._id,
                                              subcategory: sub.subcategory,
                                            },
                                            true
                                          )}
                                          sx={{ fontSize: 11, height: 24, cursor: 'pointer', borderRadius: 1 }}
                                        />
                                        <Chip
                                          label="Remove"
                                          size="small"
                                          color="error"
                                          onClick={() => deleteFunc(`/api/subcategory/delete/${sub._id}`)}
                                          sx={{ fontSize: 11, height: 24, cursor: 'pointer', borderRadius: 1 }}
                                        />
                                      </Stack>
                                    </Box>
                                  ))}
                                </Stack>
                              ) : (
                                <Box sx={{ textAlign: 'center', py: 1 }}>
                                  <Typography variant="body2" color="text.disabled">No subcategories yet</Typography>
                                </Box>
                              )}
                            </CardContent>
                          </Card>
                        );
                      })}
                    </Box>
                  ) : (
                    <Box sx={{ textAlign: 'center', py: 4, border: '1px dashed', borderColor: 'divider', borderRadius: 2 }}>
                      <Typography variant="body2" color="text.disabled">No categories yet under this shop</Typography>
                    </Box>
                  )}

                  <Divider sx={{ mt: 4 }} />
                </Box>
              );
            })}
          </Stack>
        ) : (
          <Box sx={{ textAlign: 'center', py: 10 }}>
            <Iconify icon="eva:layers-outline" width={48} sx={{ color: 'text.disabled', mb: 2 }} />
            <Typography variant="h6" color="text.disabled">No shops found</Typography>
            <Typography variant="body2" color="text.disabled">Click &quot;Add Shop&quot; to get started (e.g. Shop For Pets, Shop For Human)</Typography>
          </Box>
        )}
      </Container>

      {/* Main Category (Shop) Modal — create + edit dono */}
      <CSSTransition in={isModalOpen('mainCategory')} timeout={300} classNames="modal-transition" unmountOnExit>
        <Modal show={isModalOpen('mainCategory')} onHide={closeModal} centered>
          <Modal.Header closeButton><Modal.Title>{isEditMode ? 'Edit Shop' : 'Add Shop'}</Modal.Title></Modal.Header>
          <Modal.Body>
            <form onSubmit={formSubmit}>
              <div className="form-group mb-3">
                <p className="mb-1">Shop Name</p>
                <input type="text" name="mainCategory" value={formValue?.mainCategory || ''} className="form-control"
                  onChange={formHandle} placeholder="e.g. Shop For Pets" required />
              </div>
              <div className="form-group text-end">
                <button className="btn btn-primary" type="submit" disabled={loading}>
                  {!loading ? 'Save' : 'Saving...'}
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </CSSTransition>

      {/* Category Modal — create + edit dono */}
      <CSSTransition in={isModalOpen('category')} timeout={300} classNames="modal-transition" unmountOnExit>
        <Modal show={isModalOpen('category')} onHide={closeModal} centered>
          <Modal.Header closeButton><Modal.Title>{isEditMode ? 'Edit Category' : 'Add Category'}</Modal.Title></Modal.Header>
          <Modal.Body>
            <form onSubmit={formSubmit}>
              <div className="form-group mb-3">
                <p className="mb-1">Select Shop</p>
                <select name="mainCategory" value={formValue?.mainCategory || ''} className="form-select" onChange={selectHandle} required>
                  <option value="">Choose shop</option>
                  {mainCategoryAllData && mainCategoryAllData.map((m) => (
                    <option value={m._id} key={m._id} style={{ textTransform: 'capitalize' }}>{m.mainCategory}</option>
                  ))}
                </select>
              </div>
              <div className="form-group mb-3">
                <p className="mb-1">Category Name</p>
                <input type="text" name="category" value={formValue?.category || ''} className="form-control"
                  onChange={formHandle} placeholder="Enter category name" required />
              </div>
              <div className="form-group text-end">
                <button className="btn btn-primary" type="submit" disabled={loading}>
                  {!loading ? 'Save' : 'Saving...'}
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </CSSTransition>

      {/* Subcategory Modal — create + edit dono (jaisa pehle se tha) */}
      <CSSTransition in={isModalOpen('subcategory')} timeout={300} classNames="modal-transition" unmountOnExit>
        <Modal show={isModalOpen('subcategory')} onHide={closeModal} centered>
          <Modal.Header closeButton><Modal.Title>{isEditMode ? 'Edit Subcategory' : 'Add Subcategory'}</Modal.Title></Modal.Header>
          <Modal.Body>
            <form onSubmit={formSubmit}>
              <div className="form-group mb-3">
                <p className="mb-1">Select Category</p>
                <select name="category" value={formValue?.category || ''} className="form-select" onChange={selectHandle} required>
                  <option value="">Choose category</option>
                  {categoryalldata && categoryalldata.map((cat) => (
                    <option value={cat._id} key={cat._id} style={{ textTransform: 'capitalize' }}>{cat.category}</option>
                  ))}
                </select>
              </div>
              <div className="form-group mb-3">
                <p className="mb-1">Subcategory Name</p>
                <input type="text" name="subcategory" value={formValue?.subcategory || ''} className="form-control"
                  onChange={formHandle} placeholder="Enter subcategory name" required />
              </div>
              <div className="form-group text-end">
                <button className="btn btn-primary" type="submit" disabled={loading}>
                  {!loading ? 'Save' : 'Saving...'}
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </CSSTransition>

      {/* Category Banner Modal */}
      <CSSTransition in={isModalOpen('categoryBanner')} timeout={300} classNames="modal-transition" unmountOnExit>
        <Modal show={isModalOpen('categoryBanner')} onHide={closeModal} centered>
          <Modal.Header closeButton><Modal.Title>Update Category Banner</Modal.Title></Modal.Header>
          <Modal.Body>
            <form onSubmit={bannerUpdate}>
              <div className="form-group mb-3">
                <p className="mb-1">Category Banner Image</p>
                <input type="file" accept="image/*" name="bannerImage" className="form-control"
                  onChange={bannerFileHandle} required />
                <small className="text-danger">{fileErrMsg}</small>
                <div className="d-flex justify-content-end gap-2 pt-2">
                  {uploadLoading && progressValue > 0 && (
                    <progress className="flex-grow-1" value={progressValue} max="100" style={{ height: '5px' }} />
                  )}
                  {uploadStatus && (
                    <small className="text-success">{uploadLoading ? `${progressValue}%` : 'Uploaded ✓'}</small>
                  )}
                </div>
              </div>
              <div className="form-group text-end">
                <button className="btn btn-primary" type="submit"
                  disabled={!!fileErrMsg || loading || !formValue.bannerImage}>
                  {!loading ? 'Save' : 'Saving...'}
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </CSSTransition>
    </>
  );
};

export default Category;